'use client';

import React__default from 'react';

function SuccessIcon(_a) {
    var _b = _a.color, color = _b === void 0 ? '#6FB920' : _b, _c = _a.width, width = _c === void 0 ? 48 : _c, _d = _a.height, height = _d === void 0 ? 49 : _d;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 48 49', fill: 'none' },
        React__default.createElement("path", { d: 'M23.9998 5.30078C13.3966 5.30078 4.7998 13.8976 4.7998 24.5008C4.7998 35.104 13.3966 43.7008 23.9998 43.7008C34.603 43.7008 43.1998 35.104 43.1998 24.5008C43.1998 13.8976 34.603 5.30078 23.9998 5.30078ZM34.731 20.832L22.635 32.928C22.3342 33.2288 21.9278 33.3968 21.5038 33.3968C21.0798 33.3968 20.6718 33.2288 20.3726 32.928L14.8478 27.4032C14.2222 26.7776 14.2222 25.7664 14.8478 25.1408C15.4734 24.5152 16.4846 24.5152 17.1102 25.1408L21.5038 29.5344L32.4686 18.5696C33.0942 17.944 34.1054 17.944 34.731 18.5696C35.3566 19.1952 35.3566 20.2064 34.731 20.832Z', fill: color })));
}

export { SuccessIcon as default };
//# sourceMappingURL=index.js.map
